import { cn } from "@/lib/utils";

interface SourceStatusPillProps {
  source: "crowdstrike" | "atera" | "jumpcloud";
  linked: boolean;
}

const sourceLabels: Record<string, string> = {
  crowdstrike: "CS",
  atera: "AT",
  jumpcloud: "JC",
};

export function SourceStatusPill({ source, linked }: SourceStatusPillProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium",
        linked ? "bg-success/10 text-success" : "bg-surface-hover text-text-muted"
      )}
    >
      {sourceLabels[source] || source}
    </span>
  );
}
